import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useDeleteArea() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (id: number) => {
      return await api.barriers.deleteBarrier(id)
    },
    onSuccess: async () => {
      await client.invalidateQueries({queryKey: [QueryKeyEnum.INTEREST_AREA]})
      enqueueSnackbar('Barreira deletada com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não foi possível deletar a barreira no momento')
    },
  })
  return mutation
}
